import base from './attributes.json'
import kiring from './attributes.zh.json'
import dev from './attributes.dev.json'
import { getter } from './helper'

// To prevent repeated processing of attributes
const processed = {}

export default locale => getter(locale, processed, base, kiring, dev)



// WEBPACK FOOTER //
// ./src/settings/attributes.js